import {DataTypeGroupEnum} from "../../../enums/dashboard/DataTypeUnitEnum";
import {MetricDataUnitEnum} from "../../../enums/dashboard/MetricDataUnitEnum";
import {ChartTypesEnum} from "../../../enums/dashboard/ChartsEnum";
import {VMTypeEnum} from "../../virtualmetric/VirtualMetric";
import {WriteOnEdgeStatusEnum} from "../../../enums/dashboard/WriteOnEdgeStatusEnum";

export class UserMetricInstance {


  partitionId!: number;
  partitionName!: string;
  deviceId?: number;
  deviceName?: string;
  id!: number;
  type!: string;
  name!: string;
  alias?: string;
  dataTypeGroup?: DataTypeGroupEnum;
  dataTypeGroupMax: number | null;
  dataTypeGroupMin: number | null;
  dataTypeGroupShowAsHex!: boolean;
  dataUnit!: MetricDataUnitEnum;
  lastValue?: any;
  lastValueTs?: any;
  decimalDigits?: number | null;
  vmType?: VMTypeEnum;

  wm2eInfo!: WM2EInfo | null;
  wm2eStatus!: WM2EStatus | null;

  // CHART PROPS
  color?: string;
  chartType?: string;
  functionType?: string;

  // CARD PROP
  icon?: string;
  minVal?: number = 0;
  maxVal?: number = 100;

  // WRITEABLE FLAG FE ONLY
  isWritableOnEdge?: boolean;

  // VISIBLE FLAG FE ONLY
  isVisible?: boolean = true;

  constructor() {
    this.chartType = ChartTypesEnum.LINE;
    this.isWritableOnEdge = false;
    this.dataTypeGroupMax = null;
    this.dataTypeGroupMin = null;
  }

}

export class WM2EInfo {
  originType?: string;
  origin?: WM2EOrigin;
}

export class WM2EOrigin {
  id!: number;
  partitionId!: number;
  partitionName!: string;
  name!: string;
  deviceId!: number | null;
  deviceName!: string | null;
}

export class WM2EStatus {
  public ts!: number;
  public valueToWrite!: number | boolean | string;
  public commandStatus!: WriteOnEdgeStatusEnum;
  public koMessage?: string;
}
